import script from "./IntegrationDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationDetailsModal.vue?vue&type=style&index=0&id=03d2489e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d2489e"]])

export default __exports__